<template>
	<div class="cart-wrapper layout">
		<div class="col-xs-12">
			<div class="header-logo">
				<a class="logo" href="/">
					<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="130" height="40"
						viewBox="0 0 130 38" class="show-for-md svg-inline logo svg-inline--default">
						<path fill="#000" fill-rule="nonzero"
							d="M77.37 37.923c-.918-.185-1.683-.676-1.995-1.281-.127-.248-.252-.825-.204-.948.022-.06.159-.077.58-.077h.55l.035.227c.142.885.967 1.34 2.423 1.338.953-.002 1.785-.24 2.022-.578.269-.383.217-.871-.124-1.153-.276-.229-.718-.358-2.011-.589-1.6-.285-1.881-.351-2.255-.528-.631-.299-.906-.705-.908-1.34-.005-1.436 1.5-2.27 3.695-2.05.748.075 1.158.178 1.617.404.588.29 1.008.866 1.097 1.504l.036.264h-.586c-.521 0-.586-.01-.587-.097-.001-.221-.273-.677-.504-.845-.902-.654-2.99-.528-3.448.208-.183.296-.178.726.01.932.236.255.532.342 2.14.63 1.953.35 2.409.505 2.79.944.298.345.372.561.372 1.09 0 .434-.02.537-.149.783-.19.362-.466.602-.965.839-.62.295-1.27.405-2.355.4-.513-.003-1.075-.037-1.277-.077zm-30.425-3.446v-3.361h2.28c2.56 0 2.794.025 3.364.368.446.269.552.38.752.786.149.302.173.411.17.768-.004.797-.476 1.44-1.297 1.772l-.41.165-1.791.02-1.79.018v2.826h-1.278v-3.362zm4.423-.388c.6-.178.875-.519.877-1.084 0-.417-.16-.672-.545-.86-.387-.19-.958-.25-2.353-.25l-1.125-.001v2.278h1.434c1.108 0 1.496-.019 1.712-.083zm2.105 3.575c.087-.168 1.19-2.42 2.562-5.229l.644-1.32H58.084l.505 1.07c1.3 2.752 2.624 5.59 2.624 5.62 0 .019-.296.034-.658.034h-.66l-.434-.972-.435-.973-1.724.001-1.724.001-.444.97-.444.97-.654.002-.653.001.09-.175zm4.502-4.02c-.338-.78-.628-1.417-.645-1.417-.025 0-1.219 2.499-1.319 2.76-.023.06.21.074 1.275.074h1.304l-.615-1.417zm4.793.833v-3.361h2.405c2.555 0 2.8.019 3.444.269.72.279 1.09.802 1.09 1.537 0 .657-.315 1.18-.889 1.473l-.234.12.28.13c.327.15.596.482.645.793.018.113.056.578.086 1.032.055.862.11 1.048.333 1.119.062.02.113.084.113.143 0 .1-.046.107-.749.107h-.748l-.034-.153a3.4 3.4 0 0 0-.059-.233 11.53 11.53 0 0 1-.074-.9c-.051-.847-.084-.97-.326-1.23-.271-.291-.537-.331-2.382-.36l-1.68-.025v2.901h-1.221v-3.362zm4.872-.44c.358-.113.651-.36.738-.624.093-.283.043-.82-.095-1.006-.174-.236-.519-.398-.97-.457-.225-.029-1.065-.054-1.866-.055l-1.458-.001v2.292l1.68-.028c1.353-.023 1.736-.046 1.971-.12zm4.288.44v-3.361h1.221V37.839h-1.22v-3.362zm39.973-2.064l-.708-.051-.458-.034v-3.094l.912.033c1.034.036 1.539-.023 2.206-.26 1.092-.386 1.937-1.165 2.546-2.345.255-.495.604-1.435.693-1.867l.037-.182-.38.028c-.208.015-.922.04-1.586.058l-1.207.03-.438-.904-1.034-2.127-1-2.056c-.22-.459-.708-1.459-1.082-2.223-.374-.764-.86-1.764-1.083-2.222-.221-.459-.696-1.434-1.055-2.167-2.09-4.277-2.747-5.64-2.747-5.7 0-.03 1.324-.05 3.345-.05h3.345l.634 1.458c1.632 3.748 2.825 6.476 3.447 7.876.373.84.848 1.94 1.056 2.444.71 1.726 1.254 2.966 1.306 2.983.029.009.288-.752.577-1.691.288-.94.684-2.17.88-2.736.859-2.488 1.612-4.685 2.313-6.751.415-1.223.85-2.498.968-2.834l.213-.611 3.2-.015c1.76-.007 3.199-.002 3.199.012s-.284.783-.631 1.71c-.347.925-.92 2.457-1.273 3.405a56127.836 56127.836 0 0 1-3.187 8.557c-2.254 6.075-2.434 6.514-3.145 7.667-1.539 2.498-3.307 3.402-7.115 3.64-.82.05-2.151.06-2.748.019zM9 24.91c-2.488-.099-4.601-.397-5.932-.836-1.83-.605-2.84-1.857-3.033-3.759C0 19.991-.01 19.6.01 19.447l.037-.277h3.24c1.783 0 3.241.006 3.24.013 0 .008-.037.152-.082.32-.165.616-.083 1.081.262 1.473.67.76 2.303 1.138 4.935 1.138 2.68 0 4.472-.367 5.316-1.09.532-.455.681-1.258.366-1.962-.26-.577-.771-.94-1.663-1.175-.385-.102-.689-.124-2.276-.166-5.38-.143-7.102-.266-8.954-.641-1.478-.3-2.25-.654-2.956-1.355-.376-.375-.523-.57-.71-.945-.403-.811-.475-1.187-.48-2.473-.002-1 .01-1.155.126-1.553.07-.243.219-.618.33-.833.261-.505.954-1.212 1.466-1.496 1.012-.562 2.536-.896 5.16-1.129 1.379-.122 7.245-.143 8.572-.03 2.476.211 3.936.515 4.94 1.03.867.442 1.583 1.357 1.832 2.34.09.357.195 1.113.195 1.406v.182H16.763l-.099-.457c-.186-.87-.518-1.303-1.138-1.488-.603-.18-1.165-.226-3.113-.26-1.976-.034-2.792.011-3.672.204-.767.167-1.285.41-1.66.776-.375.368-.466.608-.458 1.206.012.863.31 1.37.907 1.54.581.168 2.414.305 5.66.424 4.944.182 7.69.591 8.944 1.333.513.304.997.84 1.265 1.404.369.773.422 1.074.423 2.375 0 1.281-.07 1.661-.446 2.407-1.05 2.08-3.397 2.923-8.909 3.204-.957.049-4.415.06-5.468.02zm39.251-.021c-5.51-.304-7.6-1.228-8.302-3.67-.086-.3-.127-.634-.149-1.23l-.03-.82h3.255c1.79 0 3.255.015 3.255.033 0 .019-.04.188-.089.375-.346 1.326.62 2.101 3.032 2.436.805.111 3.833.094 4.695-.026 1.762-.247 2.84-.743 3.192-1.47.193-.398.184-1.052-.022-1.473-.28-.573-.785-.92-1.68-1.16-.38-.1-.687-.122-2.271-.165-4.46-.119-6.026-.204-7.579-.414-2.605-.351-3.897-.897-4.696-1.984-.55-.747-.791-1.535-.839-2.744-.075-1.887.419-3.08 1.636-3.95.985-.704 2.663-1.1 5.732-1.351 1.168-.096 5.883-.134 7.3-.058 4.796.254 6.685.933 7.52 2.703.224.473.384 1.143.428 1.789l.036.514-3.071-.014-3.071-.015-.129-.525c-.36-1.471-.834-1.637-4.683-1.64-1.825-.001-2.226.013-2.745.1-1.071.181-1.86.516-2.243.953-.275.313-.359.62-.33 1.207.04.866.3 1.289.894 1.46.566.162 2.425.3 5.645.418 5.064.187 7.853.614 9.035 1.385.524.342.88.745 1.156 1.307.297.606.392.965.473 1.776.12 1.204-.078 2.341-.57 3.27-.25.467-1.015 1.238-1.523 1.532-1.278.738-3.124 1.153-6.239 1.401-.978.078-5.881.113-7.023.05zm41.666.025c-3.506-.188-5.54-.564-7.023-1.298-.986-.488-1.526-1.02-2.053-2.017-.459-.868-.746-1.886-.954-3.375-.14-1.006-.14-3.76 0-4.69.292-1.947.912-3.334 1.894-4.238.482-.445.838-.67 1.53-.969 1.188-.512 2.817-.847 5.163-1.06 1.1-.1 5.904-.1 6.967 0 2.894.272 4.818.79 5.91 1.592 1.125.827 1.845 2.208 2.173 4.17.094.562.202 2.372.215 3.598l.002.208H86.201l-.038.203c-.067.36.02 1.736.14 2.227.208.84.594 1.436 1.17 1.804.872.556 3.04.823 5.775.711 2.822-.116 3.627-.413 4-1.478.064-.18.13-.522.147-.758l.032-.431h6.319l-.035.625c-.059 1.066-.202 1.567-.624 2.19-1.063 1.566-3.409 2.495-7.286 2.885-.812.081-4.927.152-5.885.1zM97.45 13.46c-.084-1.908-.582-2.585-2.132-2.899-1.504-.304-4.548-.36-6.178-.113-1.062.16-1.797.45-2.14.845-.413.475-.675 1.304-.73 2.306l-.034.625h11.248l-.034-.764zM28.68 16.058V7.39H35.009v17.336H28.68v-8.668zm39.75-3.695V0h6.33v24.726H68.43V12.363zM28.68 1.75V0H35.009v3.5H28.68V1.75z" />
					</svg>
					<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="81" height="24"
						viewBox="0 0 81 24" class="hide-for-md svg-inline logo-small svg-inline--default">
						<path fill="#000" fill-rule="nonzero"
							d="M48.029 23.696c-.57-.115-1.045-.422-1.238-.8-.079-.155-.156-.515-.127-.592.014-.037.099-.049.36-.049h.34l.023.142c.088.553.6.838 1.504.836.592-.001 1.108-.15 1.256-.36.166-.24.134-.545-.077-.721-.172-.143-.446-.224-1.249-.368-.993-.179-1.167-.22-1.4-.33-.391-.187-.562-.44-.563-.838-.003-.897.93-1.418 2.293-1.28.465.047.72.11 1.004.252.365.18.626.541.681.94l.023.165h-.364c-.324 0-.364-.007-.364-.06-.001-.14-.17-.424-.313-.529-.56-.408-1.857-.33-2.14.13-.115.185-.112.454.006.582.146.16.33.214 1.328.394 1.212.22 1.495.315 1.731.59.186.215.232.35.232.68 0 .272-.013.337-.093.49-.118.227-.289.376-.599.525-.385.184-.788.253-1.462.25a5.744 5.744 0 0 1-.792-.049zm-18.887-2.153v-2.1h1.415c1.59 0 1.735.016 2.089.23.277.168.343.237.467.49.092.19.107.258.106.481-.004.498-.296.9-.806 1.107l-.255.104-1.112.012-1.111.011v1.766h-.793v-2.1zm2.746-.242c.372-.112.543-.324.544-.678 0-.26-.1-.42-.338-.537-.24-.118-.595-.156-1.461-.157h-.698v1.424h.89c.688 0 .929-.012 1.063-.052zm1.307 2.233c.053-.104.739-1.512 1.59-3.266l.4-.825h.872l.314.668c.806 1.72 1.629 3.493 1.629 3.512 0 .011-.184.021-.41.021h-.408l-.27-.608-.27-.607h-1.07l-1.07.001-.276.606-.276.606-.406.001-.406.001.057-.11zm2.794-2.511c-.21-.487-.39-.886-.4-.885-.016 0-.757 1.56-.819 1.724-.014.038.13.046.792.046h.809l-.382-.885zm2.976.52v-2.1h1.492c1.587 0 1.738.012 2.139.168.446.174.677.501.677.96 0 .411-.196.738-.553.92l-.145.076.174.08c.203.095.37.302.4.497.011.07.035.36.053.645.035.538.07.654.207.698.039.013.07.053.07.09 0 .063-.028.067-.464.067h-.465l-.02-.095a2.136 2.136 0 0 0-.037-.146 7.25 7.25 0 0 1-.047-.562c-.031-.53-.051-.607-.202-.769-.168-.182-.333-.207-1.479-.225l-1.042-.016V23.644h-.758v-2.1zm3.024-.275c.223-.07.404-.225.458-.39.058-.176.027-.512-.059-.628-.108-.148-.322-.249-.602-.286-.14-.018-.661-.033-1.159-.034l-.904-.001v1.432l1.042-.017c.84-.015 1.078-.03 1.224-.076zm2.662.275v-2.1h.758V23.644h-.758v-2.1zm24.814-1.29l-.44-.031-.284-.021v-1.934l.566.02c.642.023.956-.014 1.37-.161.678-.242 1.202-.728 1.58-1.466.158-.31.375-.897.43-1.167l.023-.113-.235.017c-.13.01-.573.026-.985.036l-.75.02-.271-.566-.642-1.329c-.204-.42-.483-.998-.62-1.285-.138-.286-.44-.911-.673-1.388l-.672-1.39c-.137-.286-.432-.895-.654-1.353-1.298-2.673-1.706-3.524-1.706-3.562 0-.019.822-.032 2.076-.031h2.077l.394.911a910.135 910.135 0 0 0 2.139 4.921c.232.525.527 1.213.656 1.528.441 1.078.778 1.853.81 1.863.018.006.18-.47.359-1.056.179-.587.424-1.357.546-1.71.533-1.554 1-2.927 1.436-4.218l.6-1.771.133-.382 1.986-.009c1.093-.005 1.986-.002 1.986.007 0 .01-.176.49-.392 1.068l-.79 2.128a35333.86 35333.86 0 0 1-1.978 5.347c-1.4 3.796-1.511 4.07-1.952 4.791-.956 1.56-2.053 2.126-4.417 2.274a17.01 17.01 0 0 1-1.706.012zM5.586 15.566c-1.544-.062-2.856-.248-3.682-.523-1.136-.378-1.763-1.16-1.883-2.348a3.188 3.188 0 0 1-.015-.543l.023-.174h2.012c1.106 0 2.011.004 2.011.009 0 .005-.023.095-.051.2-.103.385-.051.675.163.92.415.475 1.43.711 3.063.711 1.664 0 2.776-.229 3.3-.68.33-.285.423-.787.227-1.227-.16-.36-.478-.587-1.032-.734-.239-.064-.428-.078-1.413-.104-3.34-.09-4.409-.166-5.558-.4-.918-.188-1.398-.41-1.835-.847-.234-.234-.325-.356-.44-.59C.224 8.727.18 8.493.176 7.69c-.001-.625.006-.721.078-.97.043-.152.136-.386.205-.521.162-.315.592-.757.91-.935.628-.35 1.575-.56 3.203-.705.856-.076 4.498-.09 5.321-.018 1.537.131 2.444.321 3.068.642.537.277.982.849 1.136 1.463.056.223.121.696.121.879v.113H10.406l-.061-.285c-.116-.544-.322-.815-.707-.93-.374-.112-.723-.142-1.932-.163-1.227-.02-1.733.008-2.28.128-.476.104-.798.256-1.03.485-.233.23-.29.38-.285.754.008.539.193.855.564.962.36.104 1.498.19 3.513.265 3.069.113 4.774.37 5.552.833.319.19.62.525.786.877.228.483.262.671.262 1.484 0 .8-.044 1.038-.277 1.504-.652 1.3-2.109 1.827-5.53 2.002-.594.03-2.741.038-3.395.012zm24.366-.013c-3.42-.19-4.717-.768-5.154-2.294-.053-.187-.078-.396-.092-.769l-.019-.512h2.021c1.111 0 2.02.01 2.02.021 0 .012-.024.117-.054.235-.215.828.384 1.313 1.881 1.521.5.07 2.38.06 2.915-.016 1.094-.154 1.763-.464 1.982-.918.12-.249.114-.658-.014-.92-.174-.358-.487-.576-1.043-.725-.236-.063-.427-.077-1.41-.103-2.768-.075-3.74-.128-4.704-.259-1.618-.22-2.42-.56-2.916-1.24-.341-.467-.49-.96-.52-1.714-.047-1.18.26-1.925 1.015-2.469.611-.44 1.653-.687 3.558-.844.725-.06 3.652-.083 4.532-.036 2.977.158 4.15.583 4.668 1.689.139.295.239.714.266 1.117l.022.322L37 7.629l-1.907-.008-.08-.328c-.223-.92-.517-1.023-2.907-1.025-1.132-.001-1.382.008-1.704.063-.665.113-1.154.322-1.392.595-.17.195-.223.387-.205.754.025.541.186.806.555.912.351.101 1.505.188 3.504.262 3.144.116 4.875.384 5.609.865.325.214.546.466.717.817.185.378.244.603.294 1.11.075.752-.048 1.462-.354 2.042-.155.293-.63.774-.945.958-.794.461-1.94.72-3.873.876-.607.048-3.651.07-4.36.03zm25.865.015c-2.176-.117-3.438-.352-4.36-.811-.611-.305-.947-.637-1.274-1.26-.285-.543-.463-1.179-.592-2.109-.087-.629-.087-2.35 0-2.93.181-1.217.566-2.084 1.175-2.649.3-.278.52-.418.95-.605.738-.32 1.75-.53 3.205-.662.683-.063 3.666-.063 4.326 0 1.796.17 2.99.493 3.668.994.699.517 1.146 1.38 1.35 2.606.057.351.125 1.482.133 2.248v.13H53.512l-.023.127c-.042.225.012 1.085.087 1.392.128.524.368.897.726 1.127.541.347 1.886.514 3.585.444 1.751-.072 2.251-.258 2.483-.923.04-.113.08-.326.091-.474l.02-.27h3.923l-.022.391c-.037.666-.126.98-.388 1.368-.66.98-2.115 1.56-4.522 1.803-.505.051-3.059.095-3.654.063zm4.677-7.157c-.053-1.193-.362-1.616-1.324-1.812-.933-.19-2.823-.225-3.835-.07-.66.1-1.115.281-1.329.528-.256.296-.418.814-.453 1.44l-.02.391h6.982l-.021-.477zm-42.69 1.623V4.618H21.733V15.45H17.804v-5.416zM42.48 7.725V0H46.409v15.45H42.48V7.725zM17.804 1.094V0H21.733V2.187H17.804V1.094z" />
					</svg>
				</a>
			</div>
		</div>
		<div class="col-xs-12">
			<div class="header-breadcrumb">
				<router-link to="/" class="link-with-arrow link-with-arrow--secondary">继续购买</router-link>
			</div>
		</div>
		<div class="ms-row" v-if="
			cartInfo &&
			cartInfo.goods_list &&
			cartInfo.goods_list.goods &&
			cartInfo.goods_list.goods.length > 0
		">
			<!-- 左侧 -->
			<div class="col-xs-12 col-md-8 col-lg-9">
				<div class="ms-row">
					<div class="col-xs-12 m-cart__product-list">
						<div class="m-cart__header">
							<h1 class="heading-h2">我的购物袋</h1>
						</div>
						<div class="m-cart__header">
							<div class="m-cart__selector" @click="toggleSelectedAll">
								<i class="iconfont select-all clickable">{{
									isSelectedAll ? "&#xe640;" : "&#xe60f;"
								}}</i>全选
							</div>
						</div>
						<div class="m-cart__sub-header" v-if="siteConfigTips">
							<div class="m-cart__msg">{{ siteConfigTips }}</div>
						</div>
						<div class="m-cart__body">
							<div class="cart cart-page" v-if="cartInfo && cartInfo.goods_list">
								<template v-for="(outerItem, outerIndex) in cartInfo.goods_list.goods">
									<template v-for="(innerItem, innerIndex) in outerItem.main">
										<!-- 最后一项 && 有赠品 -->
										<template v-if="
											innerIndex + 1 == outerItem.main.length &&
											outerItem.gifts &&
											outerItem.gifts.length
										">
											<CartItem :base="innerItem" :gifts="outerItem.gifts"
												@selected="onItemSelected" @remove="onItemRemove"
												@changenum="onItemCountChange" @changesku="onItemSKUChange"
												:key="`${outerIndex}-${innerIndex}_${innerItem.sku}`" />
										</template>
										<template v-else>
											<CartItem :base="innerItem" @selected="onItemSelected"
												@remove="onItemRemove" @changenum="onItemCountChange"
												@changesku="onItemSKUChange"
												:key="`${outerIndex}-${innerIndex}_${innerItem.sku}`" />
										</template>
									</template>
								</template>
							</div>
						</div>
					</div>
					<!-- 全场赠品 -->
					<template v-if="
						cartInfo &&
						cartInfo.goods_list &&
						Array.isArray(cartInfo.goods_list.group_gifts) &&
						cartInfo.goods_list.group_gifts.length
					">
						<div class="col-xs-12 m-cart__gifts">
							<template v-for="(ggItem, ggIdx) in cartInfo.goods_list.group_gifts">
								<div class="m-cart__gifts--group" :key="`Cart-Gifts-Group-${ggIdx}`">
									<div class="m-cart__gifts--header">{{ ggItem.name }}</div>
									<div class="m-cart__gifts--list">
										<div class="m-cart__gifts__item"
											v-for="(gItem, gIdx) in merge(ggItem.gifts, 'sku_key')"
											:key="`Cart-GG-${ggIdx}-${gIdx}`">
											<div class="m-cart__gifts__item-image_wrap">
												<img class="m-cart__gifts__item-image" :src="gItem.pic"
													:alt="gItem.name" />
											</div>
											<div class="m-cart__gifts__item-info">
												<div class="m-cart__gifts__item-name">
													{{ gItem.name }}
												</div>
												<div class="m-cart__gifts__item-count">
													数量：{{ gItem.qty < 1 ? 0 : gItem.qty }} </div>
												</div>
											</div>
										</div>
									</div>
							</template>
						</div>
					</template>
					<!-- 积分兑换商品 -->
					<template v-if="
						cartInfo &&
						cartInfo.goods_list &&
						Array.isArray(cartInfo.goods_list.product_coupon_sku) &&
						cartInfo.goods_list.product_coupon_sku.length
					">
						<div class="col-xs-12 m-cart__coupon_product"
							v-if="cartInfo.goods_list.product_coupon_sku.length">
							<div class="c-product__tile">
								<h2 class="c-product__header">
									{{ cartInfo.goods_list.product_coupon_name || "尊享礼遇" }}
								</h2>
								<div class="c-product__list">
									<div class="c-product__item" v-for="(item, index) in cartInfo.goods_list
										.product_coupon_sku" :key="index">
										<div class="c-product__item-image_wrap">
											<img class="c-product__item-image" :src="item.pic" :alt="item.name" />
										</div>
										<div class="c-product__item-info">
											<h2 class="c-product__item-name">{{ item.name }}</h2>
											<div class="c-product__item-desc">
												{{ item.short_desc }}
											</div>
											<div class="c-product__item-sku" v-if="item.spec_desc">
												{{ item.display_type | classify }}：
												<span v-if="
													item.display_type == 'color' && item.spec_property
												" class="color__circle" :style="{ background: `#${item.spec_property}` }"></span>
												{{ item.spec_desc }}
											</div>
											<!-- <div class="c-product__item-money c-button--bold">￥{{item.price}}</div> -->
											<div class="c-product__item-money">免费</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<!-- 免费试用装 -->
					<div class="col-xs-12 m-cart__recommendations" v-if="freeTrialItems && freeTrialItems.length">
						<div class="c-recommendation">
							<div class="c-recommendation__header">
								<h2 v-if="
									cartInfo.order_freetry_limited_qty >= freeTrialItems.length
								">
									获得{{ freeTrialItems.length }}件星品体验装
								</h2>
								<h2 v-else>
									选择{{ cartInfo.order_freetry_limited_qty }}件星品体验装
								</h2>
								<div class="header-tile">
									选择{{ cartInfo.order_freetry_limited_qty }}件星品体验装
								</div>
								<div class="header-action" @click="toggleFreeTrials()">
									<span>更多体验装</span>
									<i class="iconfont">&#xe636;</i>
								</div>
							</div>
							<div class="ms-row">
								<div class="col-xs-6 col-sm-4" v-for="(item, index) in freeTrialItems" :key="index">
									<div class="recommendation-contanier" @click="
										cartInfo.order_freetry_limited_qty < freeTrialItems.length
											? setRealFreeTrialItem(item)
											: ''
										">
										<i :class="[
											'iconfont',
											'select-icon',
											cartInfo.order_freetry_limited_qty >=
												freeTrialItems.length
												? 'disableIcon'
												: '',
										]">{{ item.real ? "&#xe640;" : "&#xe60f;" }}</i>
										<div class="recommendation-li">
											<img :src="item.pic" :alt="item.name" />
											<div class="recommendation-name">{{ item.name }}</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 更多体验装 -->
							<div class="modal" v-show="showMoreFreeTrials">
								<div class="modal-main">
									<div class="modal-title">选择3件星品体验装</div>
									<div class="c-button c-button--rounded close-icon" @click="toggleFreeTrials()">
										<i class="iconfont">&#xe615;</i>
									</div>
									<ul class="select-list">
										<li class="select-item" v-for="(item, index) in freeTrialItems" :key="index"
											@click="setFakeFreeTrialItem(item)">
											<img class="item_image" :src="item.pic" :alt="item.name" />
											<div class="item_name">{{ item.name }}</div>
											<i class="iconfont item_status">{{
												item.fake ? "&#xe640;" : "&#xe60f;"
											}}</i>
										</li>
									</ul>
									<button class="c-button c-button--primary hide-for-sm" @click="setRealFreeTrials()">
										确定
									</button>
								</div>
							</div>
						</div>
					</div>

					<!-- spa 和 服务 -->
					<template v-if="isLogin">
						<div class="spaTip" v-if="spaAndtry.length > 0">
							<div>请选择您要参与的活动类型</div>

							<!-- 1存在 -->
							<div v-if="
								spaAndtry[0].spa_try &&
								spaAndtry[0].spa_try.length > 0 &&
								(!spaAndtry[0].try || spaAndtry[0].try.length == 0)
							">
								1. 希氏奢护
							</div>
							<!-- 2存在 -->
							<div v-else-if="
								spaAndtry[0].try &&
								spaAndtry[0].try.length > 0 &&
								(!spaAndtry[0].spa_try || spaAndtry[0].spa_try.length == 0)
							">
								1. 自选奢宠体验礼
							</div>
							<!-- 1、2都存在 -->
							<div v-else>1. 希氏奢护 2. 自选奢宠体验礼（二者不可同享）</div>
							<div>系统会根据您的订单金额计算您可选择的体验礼数量</div>
						</div>
						<div v-for="im in spaAndtry">
							<div class="col-xs-12 m-cart__recommendations" v-if="im.spa_try.length">
								<div class="c-recommendation">
									<div class="c-recommendation__header">
										<h2>希氏奢护</h2>
										<div class="header-tile">希氏奢护</div>
									</div>
									<div class="ms-row">
										<div class="col-xs-6 col-sm-4" v-for="(item, index) in im.spa_try">
											<div class="recommendation-contanier"
												@click="onSelectSpaAndTry(item, im, 'spa_try')">
												<i :class="[
													'iconfont',
													'select-icon',
													item.grey == 1 ? 'disableIcon' : '',
												]">{{ item.selected == 1 ? "&#xe640;" : "&#xe60f;" }}</i>
												<div class="recommendation-li">
													<img :src="item.pic" :alt="item.name" />
													<div class="recommendation-name">{{ item.name }}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 服务 -->
							<div class="col-xs-12 m-cart__recommendations" v-if="im.try.length">
								<div class="c-recommendation">
									<div class="c-recommendation__header">
										<h2>自选奢宠体验礼</h2>
										<div class="header-tile">自选奢宠体验礼</div>
									</div>
									<div class="ms-row">
										<div class="col-xs-6 col-sm-4" v-for="(item, index) in im.try">
											<div class="recommendation-contanier"
												@click="onSelectSpaAndTry(item, im, 'try')">
												<i :class="[
													'iconfont',
													'select-icon',
													item.grey == 1 ? 'disableIcon' : '',
												]">{{ item.selected == 1 ? "&#xe640;" : "&#xe60f;" }}</i>
												<div class="recommendation-li">
													<img :src="item.pic" :alt="item.name" />
													<div class="recommendation-name">{{ item.name }}</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
			<!-- 右侧 -->
			<div class="col-xs-12 col-md-4 col-lg-3">
				<div class="summary-wrap" v-if="cartInfo && cartInfo.total">
					<div class="heading-h2" v-if="cartInfo.total.total_amount">
						我的购物袋：￥{{ cartInfo.total.total_amount | toFixed(2) }}
					</div>
					<div class="heading-h2" v-else>我的购物袋：￥0.00</div>
					<!-- 订单摘要 -->
					<div class="item-tile summary">
						<div class="tile-container">
							<!-- 金额信息 -->
							<div class="heading-h5">订单摘要</div>
							<div class="kv-items">
								<div class="kv-line">
									<div class="kv-name">商品金额</div>
									<div class="kv-value" v-if="cartInfo.total.total_product_price">
										￥{{ cartInfo.total.total_product_price | toFixed(2) }}
									</div>
									<div class="kv-value" v-else>￥0.00</div>
								</div>
								<div class="kv-line">
									<div class="kv-name">优惠金额</div>
									<div class="kv-value" v-if="cartInfo.total.total_discount">
										-￥{{ cartInfo.total.total_discount | toFixed(2) }}
									</div>
									<div class="kv-value" v-else>￥0.00</div>
								</div>
								<div class="kv-line">
									<div class="kv-name">运费</div>
									<div class="kv-value" v-if="cartInfo.total.total_ship_fee > 0">
										+¥{{ cartInfo.total.total_ship_fee | toFixed(2) }}
									</div>
									<div class="kv-value" v-else>免费</div>
								</div>
								<div class="kv-line">
									<div class="kv-name">包装</div>
									<div class="kv-value" v-if="cartInfo.total.total_wrap_fee > 0">
										+¥{{ cartInfo.total.total_wrap_fee | toFixed(2) }}
									</div>
									<div class="kv-value" v-else>免费</div>
								</div>
							</div>
							<!-- 电子礼券 -->
							<div class="tab-wrap" v-if="isLogin">
								<div class="tab-header">
									<div :class="['tab-title', eGiftCardType == 1 ? 'active' : '']"
										@click="toggleEGiftCard(1)">
										使用电子礼券
									</div>
									<div :class="['tab-title', eGiftCardType == 2 ? 'active' : '']"
										@click="toggleEGiftCard(2)">
										输入电子礼券优惠码
									</div>
								</div>
								<div class="tab-body">
									<div class="e-gift_card" v-if="eGiftCardType == 1">
										<CouponSelect :couponCard="couponCard"
											:couponList="cartInfo.user_info.coupon_list" @onConfirm="couponConfirm">
										</CouponSelect>
									</div>
									<div class="e-gift_card_code" v-if="eGiftCardType == 2">
										<input class="c-input c-input--fullwidth" v-model.trim="eGiftCardCode"
											@blur="onCouponCodeBlur" placeholder="请输入电子礼券优惠码" />
									</div>
								</div>
							</div>
							<!-- 总计 -->
							<div class="total-info">
								<div class="kv-line">
									<div class="kv-name">总计</div>
									<div class="kv-value" v-if="cartInfo.total.total_amount">
										￥{{ cartInfo.total.total_amount | toFixed(2) }}
									</div>
									<div class="kv-value" v-else>￥0.00</div>
								</div>
							</div>
							<!-- <button class="c-button checkout-btn" :disabled="disabledCheckout" @click="toCheckout">提交订单</button> -->
							<button class="c-button checkout-btn" @click="toCheckout">
								提交订单
							</button>
							<div class="payment-methods">
								<i class="iconfont">&#xe65f;</i>
								<i class="iconfont">&#xe65b;</i>
								<i class="iconfont">&#xe65d;</i>
								<i class="iconfont">&#xe659;</i>
								<i class="iconfont">&#xe658;</i>
							</div>
						</div>
					</div>
					<Club v-if="isLogin" :config="cartInfo.total.total_get_points || 0" />
					<!-- Banner -->
					<!-- 免费配送 -->
					<div class="item-tile free-shipping">
						<div class="tile-container">
							<!-- <div class="heading-h5">免费配送</div> -->
							<div class="action-group collapse">
								<div class="action-header clickable" @click="toggleActionGroup">
									<div class="action-title">需要帮助？</div>
									<i class="iconfont minus">&#xe604;</i>
									<i class="iconfont plus">&#xe627;</i>
								</div>
								<div class="action-body">
									<div class="online-service">
										咨询官网在线美容顾问，周一至周日，10:00-22:00。
									</div>
								</div>
							</div>
							<div class="action-group collapse">
								<div class="action-header clickable" @click="toggleActionGroup">
									<div class="action-title">尊贵礼盒</div>
									<i class="iconfont minus">&#xe604;</i>
									<i class="iconfont plus">&#xe627;</i>
								</div>
								<div class="action-body">
									<div class="online-service">
										您的每一个订单都将以精美的礼盒包装快递给您，尊享官网独家购物体验，是您礼献挚爱的倾情之选。
									</div>
								</div>
							</div>
							<div class="action-group collapse">
								<div class="action-header clickable" @click="toggleActionGroup">
									<div class="action-title">礼品卡</div>
									<i class="iconfont minus">&#xe604;</i>
									<i class="iconfont plus">&#xe627;</i>
								</div>
								<div class="action-body">
									<div class="online-service">
										如您购买的Sisley产品有送礼的需求，您可以在提交订单时添加礼品卡信息，我们会将其打印在礼品卡上并将其放置在包裹中。
									</div>
								</div>
							</div>
							<div class="action-group collapse">
								<div class="action-header clickable" @click="toggleActionGroup">
									<div class="action-title">配送方式</div>
									<i class="iconfont minus">&#xe604;</i>
									<i class="iconfont plus">&#xe627;</i>
								</div>
								<div class="action-body">
									<div class="online-service">
										所有订单将优先使用顺丰速运提供免费送货服务，对于顺丰无法送到的地区，我们将使用EMS运送。
									</div>
								</div>
							</div>
							<div class="action-group collapse">
								<div class="action-header clickable" @click="toggleActionGroup">
									<div class="action-title">退换货政策</div>
									<i class="iconfont minus">&#xe604;</i>
									<i class="iconfont plus">&#xe627;</i>
								</div>
								<div class="action-body">
									<div class="online-service">7天无理由退换货</div>
								</div>
							</div>
							<div class="action-group collapse">
								<div class="action-header clickable" @click="toggleActionGroup">
									<div class="action-title">电子发票</div>
									<i class="iconfont minus">&#xe604;</i>
									<i class="iconfont plus">&#xe627;</i>
								</div>
								<div class="action-body">
									<div class="online-service">
										增值税普通电子发票申请后，将在您订单签收的15个工作日之后发送至邮箱，您也可在“我的订单-已支付”中选择重新发送。
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ms-row empty-cart-wrap" v-else>
			<div class="col-xs-12 col-md-4">
				<div class="nav-title">分类</div>
				<ul class="nav-items">
					<li class="nav-item" v-for="item in navList" :key="item.id">
						<a href="javascript:void(0);" @click="actionHandler(item.action)">{{
							item.text
						}}</a>
					</li>
				</ul>
			</div>
			<div class="col-xs-12 col-md-8">
				<div class="empty-cart-msg">
					<h2>购物袋为空</h2>
					<div class="recommend-wrap">
						<Recommend region="cart_rec" :isTitle="true" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CartItem from "@/components/CartItem.vue";
import Recommend from "@/components/Recommend.vue";
import Club from "@/components/Club.vue";
import CouponSelect from "@/components/CouponSelect.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import MultiSelect from "vue-multiselect";
import actionMixins from "@/utils/action.mixins";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";

export default {
	name: "Cart",
	mixins: [actionMixins],
	components: {
		CartItem,
		MultiSelect,
		Recommend,
		Club,
		CouponSelect,
	},
	data() {
		return {
			quantityShow: false,
			quantityIndex: 0,
			colorShow: false,
			eGiftCardType: 1,
			eGiftCardCode: "",
			showMoreFreeTrials: false,
			freeTrialItems: [],
			couponCard: [],
			spaAndtry: [],
			isAutoCoupon:true,
		};
	},
	created() { },
	mounted() {
		let localCart = utils.getCartInfo();
		if (!this.isLogin && localCart?.goods_list?.goods?.length) {
			localCart.goods_list.free_try = [];
			utils.setCartInfo(localCart);
			this.syncCartInfo(() => {
				this.initCardInfo();
				this.initFreeTrials();
			});
		} else {
			this.initCardInfo();
			this.initFreeTrials();
		}
	},
	updated() { },
	methods: {
		//
		initCardInfo() {
			if (!this.cartInfo) return;
			let { coupon_id, coupon_code, user_info, add_product_coupon_id } =
				this.cartInfo;

			if (user_info.coupon_list.length) {
				let _couponCard = [];
				user_info.coupon_list.forEach((i) => {
					if (
						(i.coupon_id === coupon_id ||
							i.coupon_id === add_product_coupon_id) &&
						!_couponCard.some((item) => item.coupon_id === i.coupon_id)
					) {
						_couponCard.push(i);
					}
				});
				
				// 自动选择卡券
				 if((!_couponCard||_couponCard.length==0)&&this.isAutoCoupon){
				       let autoCoupon=user_info.coupon_list[0];
				       for(let i=1;i<user_info.coupon_list.length;i++){
				         let item=user_info.coupon_list[i];
				         if(item.type=='coupon'&&autoCoupon.type!='coupon'){
				           autoCoupon=item;
				         }else if(item.type='coupon'&&autoCoupon.type=='coupon'&&(Number(item.total_discount)>Number(autoCoupon.total_discount))){
				           autoCoupon=item;
				         }
				       }
				       _couponCard=[autoCoupon];
				       
				   	this.couponCard = _couponCard;
					console.log("自动卡券变更========")
					this.useCoupon();
					return;
				 }                       
				this.isAutoCoupon=false
				
				this.couponCard = _couponCard;
			}
			this.eGiftCardCode = coupon_code || "";
			//
			this.gtmTrackCart();
		},
		initFreeTrials() {
			if (!this.cartInfo) return;
			console.log(this.$store.state.cartInfo.goods_list.free_try);
			this.freeTrialItems = this.$store.state.cartInfo.goods_list.free_try.map(
				(item) => {
					if (item.selected) {
						return {
							...item,
							real: true,
							fake: true,
							sync: true,
						};
					} else {
						return {
							...item,
							real: false,
							fake: false,
							sync: true,
						};
					}
				}
			);
			this.spaAndtry = this.$store.state.cartInfo.goods_list.spa_try;
		},
		//全选
		toggleSelectedAll() {
			let ids = [];
			if (this.cartInfo?.goods_list?.goods?.length) {
				ids = this.cartInfo.goods_list.goods.reduce(
					(outerPrevious, outerItem) => {
						return outerPrevious.concat(
							outerItem.main.reduce((innerPrevious, innerItem) => {
								return innerPrevious.concat(innerItem.sku_key);
							}, [])
						);
					},
					[]
				);
			}
			this.setSelectedItems(ids, !this.isSelectedAll);
		},
		// 选中状态切换
		onItemSelected(info) {
			let { item, state } = info;
			this.setSelectedItems([item.sku_key], state);
		},
		// 更新条目选中状态
		setSelectedItems(ids, state) {
			if (!ids) return;
			if (this.isLogin) {
				this.updateCartSelected({
					skus: ids.map((id) => {
						return {
							sku: id,
						};
					}),
					flag: state != undefined ? (state ? 1 : 0) : 1,
				});
			} else {
				utils.setCartItemSelected(ids, state, () => {
					this.syncCartInfo();
				});
			}
		},
		// 更新购物车条目、免费试用、电子礼券选择状态
		updateCartSelected(params, callback) {
			let {
				skus,
				free_skus,
				flag,
				coupon_id,
				coupon_code,
				spa_rule_id,
				spa_skus,
			} = params;
			if (skus && !Array.isArray(skus))
				return console.warn(`参数错误：${skus}`), false;
			if (free_skus && !Array.isArray(free_skus))
				return console.warn(`参数错误：${skus}`), false;
			if ((skus?.length || free_skus?.length) && flag == undefined)
				params.flag = 1;
			params.coupon_id = this.couponCard.length
				? this.couponCard[0].coupon_id
				: "";
			params.add_product_coupon_id =
				this.couponCard.length > 1 ? this.couponCard[1].coupon_id : "";
			params.coupon_code = coupon_code || this.eGiftCardCode;
			if (!skus && !free_skus && !coupon_id && !coupon_code && !spa_skus)
				return console.warn(`参数错误：${params}`), false;
			if (this.isLogin) {
				api[types.CART_UPDATE_SELECTED](params).then((res) => {
					if (res.code == 1) {
						utils.isFunction(callback) && callback(res.data);
						this.syncCartInfo(); // callback
					} else {
						this.$toast({
							message: res.message,
							iconCls: "failure",
						});
					}
				});
			}
		},
		// 删除
		onItemRemove(info) {
			this.$confirm({
				message: "确定要从购物车删除该商品吗？",
				showCancel: true,
			})
				.then(() => {
					let { sku_key } = info.item;
					if (this.isLogin) {
						api[types.CART_DELETE]({
							id: sku_key,
						}).then((res) => {
							if (res.code == 1) {
								res?.data?.goods_list && this.syncCartInfo();
							} else {
								this.$toast({
									message: res.message,
									iconCls: "failure",
								});
							}
						});
					} else {
						utils.delCart(sku_key, () => {
							this.syncCartInfo();
						});
					}
				})
				.catch(() => { });
		},
		// 选择数量
		onItemCountChange(info) {
			let { item, count } = info;
			if (this.isLogin) {
				api[types.CART_UPDATE]({
					id: item.sku_key,
					quantity: count,
				}).then((res) => {
					if (res.code == 1) {
						this.$store.commit(types.CART_GET, res.data);
					} else {
						this.$toast({
							message: res.message,
							iconCls: "failure",
						});
					}
				});
			} else {
				utils.updateCart(
					{
						oid: item.sku_key,
						nid: item.sku_key,
						price: item.unit_original_price,
						quantity: count,
						selected: !!item.selected,
					},
					() => {
						this.syncCartInfo();
					}
				);
			}
		},
		// 选择SKU
		onItemSKUChange(info) {
			let { item, skus } = info;
			let oid = -1,
				nid = -1;
			if (item.display_type == "collection") {
				oid = item.sku_key;
				nid = `{{${item.sku}}}${skus.map((sku) => {
					return `{{${sku.sku_id}}}`;
				})}`;
			} else if (item.display_type == "collection_sku") {
				//
			} else {
				oid = item.sku_key;
				nid = skus[0].sku_id;
			}
			if (oid == -1 || nid == -1)
				return console.warn(`参数错误：oid=${oid},nid=${nid}`), false;
			if (this.isLogin) {
				api[types.CART_UPDATE]({
					delete_sku: oid,
					id: nid,
					quantity: item.qty,
				})
					.then(() => {
						this.syncCartInfo();
					})
					.catch((err) => {
						console.warn(err);
					});
			} else {
				utils.updateCart(
					{
						oid: oid,
						nid: nid,
						price: item.price,
						quantity: item.qty,
					},
					() => {
						this.syncCartInfo();
					}
				);
			}
		},
		// 选择礼盒中商品SKU
		onGiftsItemSKUChange() { },
		// PC&H5默认: 选择免费试用商品
		setRealFreeTrialItem(item) {
			let maxSize = this.cartInfo.order_freetry_limited_qty || 3;
			let count = this.freeTrialItems.filter((item) => item.real).length;
			if (!item.real && count >= maxSize) {
				return (
					this.$toast({
						message: `最多可选${maxSize}个免费试用装`,
					}),
					false
				);
			}
			item.real = !item.real;
			item.sync = true;
			if (this.isLogin) {
				this.updateCartSelected({
					free_skus: [
						{
							sku: item.sku_key,
						},
					],
					flag: item.real ? 1 : 0,
				});
			} else {
				utils.updateFreeTrialStatus(
					{
						id: item.sku_key,
						state: item.real,
					},
					() => {
						this.syncCartInfo();
					}
				);
			}
		},
		// H5弹窗: 选择免费试用商品
		setFakeFreeTrialItem(item) {
			let maxSize = this.cartInfo.order_freetry_limited_qty || 3;
			let count = this.freeTrialItems.filter((item) => item.fake).length;
			if (!item.fake && count >= maxSize) {
				return (
					this.$toast({
						message: `最多可选${maxSize}个免费试用装`,
					}),
					false
				);
			}
			item.fake = !item.fake;
			item.sync = false;
		},
		// H5弹窗: 确认选中的免费试用商品
		setRealFreeTrials() {
			let unsyncItems = this.freeTrialItems
				.filter((item) => !item.sync)
				.map((item) => {
					return {
						id: item.sku_key,
						real: item.real,
						fake: item.fake,
					};
				});
			let unSelected = [],
				selected = [];
			unsyncItems.forEach((item) => {
				if (item.real == item.fake) {
					// return false;
				} else if (item.real && !item.fake) {
					unSelected.push({
						sku: item.id,
					});
				} else if (!item.real && item.fake) {
					selected.push({
						sku: item.id,
					});
				}
			});
			if (this.isLogin) {
				if (unSelected.length) {
					api[types.CART_UPDATE_SELECTED]({
						free_skus: unSelected,
						flag: 0,
					})
						.then((outerRes) => {
							if (outerRes.code == 1) {
								if (selected.length) {
									api[types.CART_UPDATE_SELECTED]({
										free_skus: selected,
										flag: 1,
									})
										.then((innerRes) => {
											if (innerRes.code == 1) {
												this.syncCartInfo();
												this.showMoreFreeTrials = false;
											} else {
												this.$toast({
													message: innerRes.message,
													iconCls: "failure",
												});
											}
										})
										.catch((innerErr) => {
											console.warn(innerErr);
										});
								} else {
									this.syncCartInfo();
									this.showMoreFreeTrials = false;
								}
							} else {
								this.$toast({
									message: outerRes.message,
									iconCls: "failure",
								});
							}
						})
						.catch((outerErr) => {
							console.warn(outerErr);
						});
				} else if (selected.length) {
					api[types.CART_UPDATE_SELECTED]({
						free_skus: selected,
						flag: 1,
					})
						.then((innerRes) => {
							if (innerRes.code == 1) {
								this.syncCartInfo();
								this.showMoreFreeTrials = false;
							} else {
								this.$toast({
									message: innerRes.message,
									iconCls: "failure",
								});
							}
						})
						.catch((innerErr) => {
							console.warn(innerErr);
						});
				}
			} else {
				if (unSelected.length) {
					utils.setCartItemSelected(
						unSelected.map((item) => item.sku),
						false,
						() => {
							if (selected.length) {
								utils.setCartItemSelected(
									selected.map((item) => item.sku),
									true,
									() => {
										this.syncCartInfo();
										this.showMoreFreeTrials = false;
									}
								);
							} else {
								this.syncCartInfo();
								this.showMoreFreeTrials = false;
							}
						}
					);
				} else if (selected.length) {
					utils.setCartItemSelected(
						selected.map((item) => item.sku),
						true,
						() => {
							this.syncCartInfo();
							this.showMoreFreeTrials = false;
						}
					);
				}
			}
		},
		// Mobile: 查看更多免费试用商品
		toggleFreeTrials() {
			this.showMoreFreeTrials = !this.showMoreFreeTrials;
		},
		// 刷新购物车数据
		syncCartInfo(callback) {
			this.$store.dispatch(types.CART_GET, callback);
		},
		// 切换电子礼券显示状态
		toggleEGiftCard(type) {
			this.eGiftCardType = type;
		},
		// 优惠码输入框失焦
		onCouponCodeBlur() {
			this.useCoupon();
		},
		// 选择电子礼券
		// eslint-disable-next-line no-unused-vars
		onSelectEGC(item) {
			setTimeout(() => {
				this.useCoupon();
			}, 0);
		},
		couponConfirm(item) {
			this.couponCard = item;
			setTimeout(() => {
				this.useCoupon();
			}, 0);
		},
		// 更新优惠券使用
		useCoupon() {
			if (this.couponUpdating) return false;
			this.couponUpdating = true;
			//
			let { eGiftCardCode: code, couponCard } = this;
			//
			let newArgs = {
				coupon_id: couponCard.length ? couponCard[0].coupon_id : "",
				add_product_coupon_id:
					couponCard.length > 1 ? couponCard[1].coupon_id : "",
				coupon_code: code,
			};
			api[types.CART_UPDATE_SELECTED](newArgs)
				.then((res) => {
					this.couponUpdating = false;
					if (res.code == 1) {
						this.syncCartInfo();
						// 无效的优惠码
						res?.data?.error_message &&
							this.$toast({
								message: res.data.error_message,
								iconCls: "failure",
							});
					} else {
						this.$toast({
							message: res.message,
							iconCls: "failure",
						});
					}
				})
				.catch((err) => {
					this.couponUpdating = false;
					console.warn(err);
				});
		},
		//
		toggleActionGroup(evt) {
			let dom = evt.target || evt.srcElement;
			let group = utils.closest(dom, ".action-group");
			group.classList.toggle("collapse");
		},
		/**
		 * 渠道上报
		 * @param  从内存中读取channel 和 entrance
		 */
		pushChannel() {
			const activityChannel = localStorage.getItem("channel") || "";
			const entrance = localStorage.getItem("entrance") || "";
			api[types.REPORT_CHANNEL]({
				activityChannel,
				entrance,
			})
				.then((res) => { })
				.catch((err) => {
					console.warn(err);
				});
		},
		// 去结算
		toCheckout() {
			this.pushChannel();
			if (this.couponUpdating) return console.info("正在更新电子礼券……"), false;
			if (this.disabledCheckout) {
				return (
					this.$alert({
						message: `请选择您的商品`,
					}),
					false
				);
			}
			let maxSize = this.cartInfo.order_freetry_limited_qty || 0;
			let count = this.freeTrialItems.filter((item) => item.real).length;
			if (maxSize != count) {
				return (
					this.$alert({
						message: `选择${maxSize}件星品体验装`,
					}),
					false
				);
			}
			this.checkCartStock(() => {
				utils.removeItem("outer");
				if (this.isLogin) {
					this.$router.push({
						name: "Checkout",
					});
				} else {
					this.$store.commit("toggleShowVisitor", true);
					this.$store.commit("toggleLogin", true);
				}
			});
		},
		// 购物车预购商品库存检查
		checkCartStock(callback) {
			if (this.stockChecking) return console.info("请勿频繁请求"), false;
			this.stockChecking = true;
			let newArgs = null;
			// 未登录
			if (!this.isLogin) {
				newArgs = {};
				let localCart = utils.getCartInfo();
				//
				let ret = localCart.goods_list.goods.map(
					(item) => `${item.id},${item.quantity},${item.selected ? 1 : 0}`
				);
				newArgs.ids = ret.join("|");
				//
				let free = localCart.goods_list.free_try.map((item) => item.id);
				free.length && (newArgs.free_ids = free.join(","));
			}
			api[types.CART_STOCK_CHECK](newArgs)
				.then((res) => {
					this.stockChecking = false;
					if (res.code == 1) {
						typeof callback == "function" && callback();
					} else {
						this.$message({
							message: res.message,
							iconCls: "failure",
						});
					}
				})
				.catch((err) => {
					this.stockChecking = false;
					console.warn(err);
				});
		},
		//
		merge(items, field) {
			if (Array.isArray(items) && items.length && field) {
				if (items[0].qty > 0) {
					//兼容新版API
					return items;
				}
				let retMap = {},
					fieldMap = {};
				items.forEach((item) => {
					if (item[field]) {
						if (fieldMap[item[field]]) {
							retMap[item[field]].qty += 1;
						} else {
							fieldMap[item[field]] = 1;
							retMap[item[field]] = {
								...item,
								qty: 1,
							};
						}
					}
				});
				return Object.values(retMap);
			}
			return items;
		},
		// GTM
		gtmTrackCart() {
			if (!window.dataLayer) return false;
			window.dataLayer.push({
				event: "checkout",
				ecommerce: {
					checkout: {
						actionField: {
							step: 1,
						},
						products: this.cartInfo.goods_list.goods.reduce(
							(ret, curr) => {
								return {
									items: ret.items.concat(
										curr.main.map((item) => {
											return {
												id: item.sku_key,
												name: item.name,
												price: item.price,
												quantity: item.qty,
												productType:
													["collection", "collection_sku"].indexOf(
														item.display_type
													) != -1
														? "bundle"
														: item.origin_product_data?.skus?.length > 1
															? "configured"
															: "simple",
												position: ret.count,
											};
										})
									),
									count: ret.count + curr.main.length,
								};
							},
							{
								items: [],
								count: 0,
							}
						).items,
					},
				},
			});
		},
		/** soa / 服务 选择 */
		onSelectSpaAndTry(item, im, type) {
			console.log(item);
			if (item.grey == 1) {
				return;
			}
			if (this.isLogin) {
				this.updateCartSelected({
					spa_rule_id: im.rule_id,
					spa_skus: [
						{
							sku: item.sku_key,
						},
					],
					flag: item.selected == 1 ? 0 : 1,
				});
			} else {
				//  utils.updateSpaAndTryStatus({
				//    rule_id: im.rule_id,
				//    id: item.sku_key ,
				//    flag: item.selected==1 ? 0 : 1,
				// type:type,
				//  }, () => {
				//    this.syncCartInfo();
				//  });
			}
		},
	},
	computed: {
		isLogin() {
			return this.$store.state.isLogin;
		},
		navList() {
			return this.$store.getters.navList;
		},
		cartInfo() {
			return this.$store.state.cartInfo;
		},
		isSelectedAll() {
			let itemCount = 0;
			let selectedCount = 0;
			this.$store.state.cartInfo.goods_list.goods.forEach((outerItem) => {
				outerItem.main.forEach((innerItem) => {
					itemCount++;
					if (innerItem.selected) selectedCount++;
				});
			});
			return itemCount === selectedCount;
		},
		// 结算按钮禁用状态控制
		disabledCheckout() {
			let ret = true;
			let selectedCount = 0;
			if (this.cartInfo.goods_list.goods.length) {
				selectedCount = this.cartInfo.goods_list.goods.reduce(
					(outerPrevious, outerCurrent) => {
						return (
							outerPrevious +
							outerCurrent.main.reduce((innerPrevious, innerCurrent) => {
								return innerPrevious + (innerCurrent.selected ? 1 : 0);
							}, 0)
						);
					},
					0
				);
				selectedCount > 0 && (ret = false);
			}
			return ret;
		},
		siteConfigTips() {
			return this.$store.state?.siteConfig?.CART_TIPS?.tips;
		},
	},
	watch: {
		"cartInfo.goods_list.free_try"() {
			this.initFreeTrials();
		},
		"cartInfo.user_info.coupon_list"() {
			this.initCardInfo();
		},
	},
};
</script>

<style lang="scss" scoped>
.spaTip {
	color: #999;
	padding: 0 1rem;
	margin-bottom: 10px;
	// font-weight: 600;
}

.color__circle {
	display: inline-block;
	height: 0.625rem;
	width: 0.625rem;
	border-radius: 50%;
	margin-right: 0.5rem;
}

.cart-wrapper {
	box-sizing: border-box;

	.col-xs-12 {
		padding: 0;
	}

	.ms-row {
		margin: 0 auto;
	}

	.header-logo {
		padding: 1.875rem 0;
		display: flex;
		justify-content: center;

		.logo {
			svg {
				width: 8.125rem;
				height: auto;
			}
		}
	}

	.header-breadcrumb {
		padding: 0.625rem 1rem;

		.link-with-arrow {
			margin-left: 0.625rem;
			color: #666666;

			&:after {
				right: auto;
				left: -0.625rem;
				transform: rotate(-90deg);
			}
		}
	}

	.m-cart__header {
		padding: 0 1rem 1.4375rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.heading-h2 {
			display: none;
			font-size: 1.5rem;
			color: #282828;
		}

		.m-cart__selector {
			cursor: pointer;
		}
	}

	.m-cart__sub-header {
		.m-cart__msg {
			margin-left: 2.625rem;
			color: #d71212;
		}
	}

	.select-all {
		margin-right: 0.625rem;
		color: #333;
	}

	.m-cart__body {
		padding: 0 1rem;
	}

	.empty-cart-wrap {
		flex-direction: column-reverse;
		padding-left: 1.25rem;

		.nav-title {
			font-size: 0.875rem;
			color: #282828;
			font-weight: 700;
			margin: 4.375rem 0 0.5rem 0;
		}

		.nav-items {
			margin-bottom: 3.25rem;

			.nav-item {
				padding: 0.5rem 0;

				a {
					text-decoration: none;
				}
			}
		}

		.empty-cart-msg {
			h2 {
				color: #282828;
				text-align: center;
				margin-top: 3.875rem;
			}

			.recommend-wrap {
				margin-top: 4.375rem;

				& /deep/ .header {
					font-size: 0.875rem;
					color: #282828;
					font-weight: 700;
					text-align: left;
				}
			}
		}
	}
}

// 全场促销
.m-cart__gifts {
	border-top: 1px solid #cfd0d1;
	border-bottom: 1px solid #cfd0d1;
	padding-bottom: 1rem !important;
	padding-left: 1rem !important;
	margin-bottom: 3.125rem;

	.m-cart__gifts--group {
		.m-cart__gifts--header {
			font-size: 14px;
			color: #000;
			font-weight: 700;
			padding: 1rem 0 1rem 0;
		}

		.m-cart__gifts--list {
			.m-cart__gifts__item {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				padding-bottom: 1rem;

				&:last-child {
					padding-bottom: 0;
				}

				.m-cart__gifts__item-image_wrap {
					padding-right: 0.625rem;

					.m-cart__gifts__item-image {
						width: 62px;
						min-width: 62px;
						height: auto;
					}
				}

				.m-cart__gifts__item-info {
					.m-cart__gifts__item-name {
						color: #000;
					}

					.m-cart__gifts__item-count {
						font-size: 12px;
						line-height: 1;
						margin-top: 10px;
					}
				}
			}
		}

		&:first-child {
			.m-cart__gifts--header {
				padding-top: 2rem;
			}
		}
	}
}

// 积分兑换商品
.m-cart__coupon_product {
	.c-product__list {
		margin-top: 20px;

		.c-product__item {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-bottom: 1rem;

			.c-product__item-image_wrap {
				min-height: 7.5rem;
				margin: 0 20px;

				.c-product__item-image {
					max-width: 106px;
					height: auto;
				}
			}

			.c-product__item-info {
				.c-product__item-name {
					font-size: 1rem;
				}
			}
		}
	}
}

// .m-cart__recommendations {
//   .c-recommendation {
//     .ms-row {
//       .col-xs-6:nth-child(n+5) { display: none; }
//     }
//   }
// }
.c-recommendation__header {
	display: flex;
	justify-content: space-between;
	padding: 0 1rem;
	margin-bottom: 20px;

	h2 {
		display: none;
	}

	.header-tile {
		font-weight: 500;
		font-size: 18px;
	}

	.header-action {
		cursor: pointer;
		display: none;
	}
}

.recommendation-contanier {
	display: flex;
	align-items: center;
	margin-bottom: 1.25rem;
	flex-direction: column-reverse;
	cursor: pointer;

	.iconfont {
		color: #333;
	}

	.recommendation-name {
		height: 2rem;
		margin-top: 10px;
	}

	.recommendation-li {
		display: flex;
		align-items: center;
		flex-direction: column;

		img {
			width: 64px;
			height: auto;
			max-height: 84px;
		}
	}
}

//
.modal {
	position: fixed;
	top: 0;
	left: 0;
	min-width: 100%;
	height: 100%;
	z-index: 99;
	background-color: rgba(0, 0, 0, 0.5);
}

.modal-main {
	width: 100%;
	height: auto;
	max-height: 580px;
	padding: 1.875rem;
	overflow: auto;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1;
	background: #fff;
	box-shadow: 0 0 0.625rem 0 #ccc;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;

	.modal-title {
		font-size: 18px;
		color: #282828;
		padding-bottom: 1.875rem;
	}

	.close-icon {
		display: block;
		width: 1.5rem;
		height: 1.5rem;
		line-height: 1.4rem;
		text-align: center;
		position: absolute;
		right: 1.25rem;
		top: 1.25rem;
	}

	.select-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
		max-height: 410px;
		overflow: scroll;

		.select-item {
			width: calc((100% - 50px) / 2);
			margin-top: 28px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;

			&:nth-child(-n + 2) {
				margin-top: 0;
			}

			.item_image {
				width: 75px;
				height: auto;
				max-height: 101px;
			}

			.item_name {
				font-size: 12px;
				color: #282828;
				line-height: 1;
				margin-top: 20px;
			}

			.item_status {
				font-size: 18px;
				color: #333;
				margin-top: 20px;
			}
		}
	}

	button.hide-for-sm {
		display: block;
		width: 100%;
	}
}

.item-tile {
	margin: 2rem 0;

	.tile-title {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.heading-h4 {
			font-size: 18px;
			font-weight: 700;
			margin-bottom: 0;
			white-space: nowrap;
		}

		.title-desc {
			font-size: 14px;
			color: #575757;

			&.float-left {
				margin-left: 0.625rem;
			}
		}

		&.space-between {
			justify-content: space-between;
		}
	}

	.tile-container {
		&.tile-border {
			border: 1px solid #d2d2d2;
		}

		&.tile-padding {
			padding: 1.5625rem 1.25rem;
		}

		.c-input {
			border: 1px solid #cccccc;
		}

		.action-group {
			border-bottom: 1px solid #dcdcdc;
			transition: height 0.2s ease-in;

			.action-header {
				height: 52px;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			.action-body {
				padding-bottom: 20px;

				.online-service {
					font-size: 12px;
					display: flex;
					justify-content: flex-start;
					align-items: center;

					.iconfont {
						margin-right: 4px;
					}
				}
			}

			.minus {
				display: block;
			}

			.plus {
				display: none;
			}

			&.collapse {
				height: 52px;
				overflow: hidden;

				.minus {
					display: none;
				}

				.plus {
					display: block;
				}
			}
		}
	}

	.btn {
		color: #ffffff;
		background: #000000;
	}

	.btn[disabled] {
		color: #999999;
		background-color: #cccccc;
	}

	&.border-top {
		border-top: 1px solid #d7d8d8;
		margin-top: -1rem;
	}
}

.summary-wrap {
	padding: 0 1rem;
}

.summary-wrap .heading-h2 {
	display: none;
	font-size: 1.5rem;
	color: #282828;
}

.summary .heading-h5 {
	font-size: 14px;
	font-weight: 700;
}

.kv-line {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 12px;
	color: #5e5e5e;
	line-height: 28px;
}

.tab-wrap {
	.tab-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.tab-title {
			font-size: 12px;
			color: #5e5e5e;
			margin-left: 1rem;
			cursor: pointer;

			&:first-child {
				margin-left: 0;
			}

			&.active {
				color: #000000;
				text-decoration: underline;
				font-weight: 700;
			}
		}
	}

	.tab-body {
		padding: 20px 0;

		.e-gift_card {
			select {
				width: 100%;
				height: 44px;
				border: 1px solid #cccccc;
				border-radius: 1.40625rem;
				padding: 0 0.625rem;
			}
		}
	}
}

.summary .tab-wrap {
	margin-top: 1rem;
}

.total-info {
	.kv-line {
		font-size: 16px;
		color: #282828;
	}
}

.payment-methods {
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-top: 1rem;

	.iconfont {
		font-size: 24px;
		color: #c0c0c0;
	}
}

.checkout-btn {
	width: 100%;
	border-radius: 1.275rem;
	color: #fff;
	font-size: 12px;
	background: #000;
	margin: 1.25rem 0;
}

.c-cart-summary__sisley-club {
	margin-bottom: 2.1875rem;

	.c-sisley-club__bg-image {
		max-height: calc(100% - 2.5rem);
	}
}

.c-sisley-club__wrapper {
	position: relative;
}

.c-sisley-club__bg-image {
	width: 100%;
	overflow: hidden;
}

.absolute-center {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.c-sisley-club__content {
	padding: 0 1.25rem;
}

.c-sisley-club--bg {
	background: #fff;
	position: relative;
	color: #000;
	font-size: 1rem;
	line-height: 1.5;
	padding: 0;
	overflow: hidden;

	.c-sisley-club__image {
		&:first-child {
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			padding: 20px;
			z-index: 1;
			text-align: right;
		}

		img {
			width: 100%;
		}
	}
}

.image--contain {
	object-fit: contain;
	object-position: center;
}

.c-sisley-club {
	border: 0.0625rem solid #f5f5f5;
	padding-bottom: 2.5rem;
}

.c-sisley-club__texts-container {
	padding: 5.3125rem 1.375rem;
}

.c-cart-summary__sisley-club picture {
	display: block;
	max-height: 100%;
	width: 100%;
}

.m-cart__coupon_product {
	margin-bottom: 3.125rem;

	.c-product__header {
		font-weight: 500;
		font-size: 18px;
		padding: 0 1rem;
	}
}

@media only screen and (min-width: 48rem) {
	.cart-wrapper {
		.header-breadcrumb {
			padding: 0.625rem 0;
		}

		.m-cart__header {
			padding: 0 0 1.4375rem;
			font-weight: 500;
		}

		.m-cart__sub-header {
			.m-cart__msg {
				margin-left: 1.625rem;
			}
		}

		.m-cart__recommendations {
			.c-recommendation {
				.ms-row {
					.col-xs-6:nth-child(n + 5) {
						display: block;
					}
				}
			}
		}

		.c-recommendation__header {
			padding: 0;

			h2 {
				display: block;
			}

			div {
				display: none;
			}
		}

		.m-cart__body {
			padding: 0;
		}

		.empty-cart-wrap {
			.empty-cart-msg {
				padding-bottom: 4rem;
			}
		}
	}

	.select-icon {
		margin-right: 0.75rem;
	}

	.disableIcon {
		pointer-events: none;
		opacity: 0;
	}

	.c-sisley-club__texts-container {
		padding: 3.125rem 1.375rem;
	}

	.recommendation-contanier {
		flex-direction: row;

		.recommendation-name {
			margin-left: 0.75rem;
			margin-top: 0;
			height: auto;
		}

		.recommendation-li {
			display: flex;
			align-items: center;
			flex-direction: row;
		}
	}

	// 全场促销
	.m-cart__gifts {
		.m-cart__gifts--group {
			.m-cart__gifts--list {
				display: flex;
				padding-right: 0 !important;

				.m-cart__gifts__item {
					// display: flex; justify-content: flex-start; align-items: center; padding-bottom: 1rem;
					width: 50%;

					&:last-child {
						padding-bottom: 1rem;
					}
				}
			}
		}
	}
}

@media only screen and (min-width: 64rem) {
	.cart-wrapper {
		.ms-row .col-xs-12 .ms-row {
			padding-right: 100px;
		}

		.m-cart__header {
			.heading-h2 {
				display: block;
			}
		}

		.empty-cart-wrap {
			flex-direction: row;
			padding-left: 0;

			.col-md-4 {
				padding-left: 1rem;
			}

			.empty-cart-msg {
				h2 {
					text-align: left;
				}
			}
		}
	}

	.item-tile {

		// padding: 0 1.25rem;
		.tile-title {
			padding: 0;
			flex-direction: column;
			align-items: flex-start;

			.heading-h4 {
				font-size: 16px;
			}

			.title-desc.float-left {
				margin-left: 0;
				margin-top: 1rem;
			}

			&.space-between {
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
			}
		}

		.tile-container {
			&.tile-border {
				border: none;
			}

			&.tile-padding {
				padding: 0.625rem 0;
			}
		}
	}

	.summary-wrap .heading-h2 {
		display: block;
	}

	.c-sisley-club__texts-container {
		padding: 5.3125rem 1.375rem;
	}

	.m-cart__coupon_product {
		.c-product__list {
			.c-product__item {
				.c-product__item-image_wrap {
					.c-product__item-image {
						width: 106px;
						height: auto;
						max-height: 140px;
					}
				}
			}
		}
	}

	//
	.m-cart__coupon_product {
		margin-bottom: 3.125rem;

		.c-product__header {
			font-weight: 500;
			font-size: 1.5625rem;
			padding: 0 1rem;
		}
	}
}

@media only screen and (min-width: 75rem) {
	.spaTip {
		padding: 0;
	}

	// 全场促销
	.m-cart__gifts {
		padding-left: 0 !important;

		.m-cart__gifts--group {
			.m-cart__gifts--list {
				padding-right: 0 !important;

				.m-cart__gifts__item {
					width: 33.333333%;

					&:last-child {
						padding-bottom: 1rem;
					}
				}
			}
		}
	}
}
</style>